/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TradeFromJSON(json) {
    return TradeFromJSONTyped(json, false);
}
export function TradeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'workerId': !exists(json, 'workerId') ? undefined : json['workerId'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'createIndex': !exists(json, 'createIndex') ? undefined : json['createIndex'],
        'autoAssignWorkerFlag': !exists(json, 'autoAssignWorkerFlag') ? undefined : json['autoAssignWorkerFlag'],
    };
}
export function TradeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'workerId': value.workerId,
        'jobType': value.jobType,
        'rank': value.rank,
        'createIndex': value.createIndex,
        'autoAssignWorkerFlag': value.autoAssignWorkerFlag,
    };
}
